module.exports = __webpack_public_path__ + "static/iterate-desk-d1338a046e2532d64b68996f01f69144.png";